export default class InputGetOperations
{
  constructor(pageNumber, resultsNumber, startDate, endDate, task, place, person, tool, orderBy) 
  {
    this.pageNumber = pageNumber;
    this.resultsNumber = resultsNumber;
    this.startDate = startDate;
    this.endDate = endDate;
    this.task = task;
    this.place = place;
    this.person = person;
    this.tool = tool;
    this.orderBy = orderBy;
  }    
}